import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
import { saveSuperUnreadMessages } from "../../redux/actions";
import Header from "../../components/Header";
import MyModal from "../../components/MyModal";
import Firebase from "../../firebasehelper";

import "./index.css";
import {
  SalesManagerOptions,
  Characters,
  SectorOptions,
  TerritoryOptions,
} from "../../Constants/brand";

const stageOptions = [
  "All",
  "Introduction",
  "Explore",
  "Decision & Commercials",
];
const UKIcon = require("../../assets/media/countries/uk.png");
const USAIcon = require("../../assets/media/countries/usa.png");
const IrelandIcon = require("../../assets/media/countries/ireland.png");
const CanadaIcon = require("../../assets/media/countries/canada.png");
const AustraliaIcon = require("../../assets/media/countries/australia.png");
const FranceIcon = require("../../assets/media/countries/france.png");
const GermanIcon = require("../../assets/media/countries/german.png");
const IndiaIcon = require("../../assets/media/countries/india.png");
const SouthAfricaIcon = require("../../assets/media/countries/south-africa.png");

const TerritoryIcon = {
  UK: UKIcon,
  Ireland: IrelandIcon,
  USA: USAIcon,
  Canada: CanadaIcon,
  Australia: AustraliaIcon,
  German: GermanIcon,
  France: FranceIcon,
  India: IndiaIcon,
  SouthAfrica: SouthAfricaIcon,
};

class BrandChannel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      brands: [],
      isLoading: true,
      stageFilter: {
        value: "All",
        label: "All",
      },
      salesManager: {
        value: "all",
        label: "All",
      },
      brandNameFilter: {
        value: "all",
        label: "All",
      },
      sectorFilter: {
        value: "all",
        label: "All",
      },
      territoryFilter: {
        value: "all",
        label: "All",
      },
      allSectors: [],
    };
  }

  componentDidMount() {
    const { role } = this.props.location.state;
    const umbrellaBrand = Number(localStorage.getItem("umbrella"));

    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      if (role !== 0 && role !== 10) this.props.history.push("/");
    }
    // get All brands
    Firebase.getAllBrands((res) => {
      let total_brands = res
        .map((item, index) => {
          let new_item = item;
          new_item.id = index;
          return new_item;
        })
        .filter((item) => item && !item.deactive);
      const br = total_brands.find((brand) => brand.name === "Weshare");
      let brands = total_brands.filter(
        (item) =>
          !(
            item.salesStage === "Test Roll Out" ||
            item.salesStage === "Full Roll Out"
          ) && !item.umbrella
      );
      if (role === 10) {
        brands = brands.filter((obj) => obj.parent === umbrellaBrand);
      }
      //get All unread messages from brands
      Firebase.getAllUnReadMessagesSentFromAdmins(this.subscribeUnreadMessages);
      this.setState({ brands, total_brands });
      Firebase.getAllSectors().then((res) => {
        this.setState({ allSectors: res, isLoading: false });
      });
    });
  }

  subscribeUnreadMessages = (unreads) => {
    let super_unreads = [];
    Object.keys(unreads).forEach((brand_id) => {
      Object.keys(unreads[brand_id]).forEach((ticket_id) => {
        const id = brand_id + "_" + ticket_id;
        super_unreads.push({
          id,
          ...unreads[brand_id][ticket_id],
        });
      });
    });
    this.props.dispatch(saveSuperUnreadMessages(super_unreads));
  };

  filterBrands = () => {
    const {
      brands,
      stageFilter,
      salesManager,
      brandNameFilter,
      sectorFilter,
      territoryFilter,
    } = this.state;

    let filtered = [];
    if (stageFilter.value === "All") {
      filtered = [...brands];
    } else {
      filtered = brands.filter((item) => item.salesStage === stageFilter.value);
    }

    if (salesManager.value !== "all") {
      filtered = filtered.filter(
        (item) => item.salesManager === salesManager.value
      );
    }

    if (brandNameFilter.value !== "all") {
      filtered = filtered.filter((item) =>
        item.name.toLowerCase().startsWith(brandNameFilter.value.toLowerCase())
      );
    }

    if (territoryFilter.value !== "all") {
      filtered = filtered.filter((item) => {
        item.territory = item.territory || "UK";
        if (
          item.territory
            .toLowerCase()
            .startsWith(territoryFilter.value.toLowerCase())
        )
          return true;
      });
    }

    if (sectorFilter.value !== "all") {
      filtered = filtered.filter((item) => item.sector === sectorFilter.value);
    }
    return filtered;
  };

  addBrand = (
    brandName,
    brandUrl,
    logo_img,
    icon_img,
    hexcode,
    territory,
    umbrella
  ) => {
    const { role } = this.props.location.state;
    const umbrellaBrand = Number(localStorage.getItem("umbrella"));

    Firebase.addFiletoBrand(
      brandName,
      brandUrl,
      logo_img,
      icon_img,
      hexcode,
      territory,
      umbrella,
      (res) => {
        console.log("image url", res);
        if (res !== "error") {
          Firebase.createDefaultBrandAdmin(res, brandName);
          if (role === 10 && umbrellaBrand) {
            Firebase.updateBrandDataById(res, { parent: umbrellaBrand });
          }
        }
      }
    );
  };

  goToBrandAdmin = (brand) => () => {
    this.props.history.push("/planner", {
      username: this.props.location.state.username,
      role: this.props.location.state.role,
      brand: brand.id,
    });
  };

  onFilterChanged = (filter) => {
    this.setState({
      filter,
    });
  };

  renderFilter = () => (
    <div className="filter_tab">
      <button className="btn" onClick={() => this.onFilterChanged("all")}>
        View All
      </button>
      <button
        className="btn"
        onClick={() => this.onFilterChanged("Introduction")}
      >
        Introduction
      </button>
      <button className="btn" onClick={() => this.onFilterChanged("Explore")}>
        Explore
      </button>
      <button className="btn" onClick={() => this.onFilterChanged("Decision")}>
        Decision
      </button>
      <button
        className="btn"
        onClick={() => this.onFilterChanged("Commercials")}
      >
        Commercials
      </button>
    </div>
  );

  showBrands = () => {
    const filteredBrands = this.filterBrands();
    filteredBrands.sort(function (a, b) {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return filteredBrands.map((item) => {
      const logo = item.logo;
      const brand = item.id;
      const territory = item.territory ? item.territory : "UK";
      return (
        <div className="brand-item-container" key={item.id}>
          <Link
            to={{
              pathname: "/planner",
              state: {
                brand: brand,
                username: username,
                role: role,
              },
            }}
            className="block block-rounded block-link-pop text-center"
          >
            <div className="logo-container">
              <img src={logo} alt="logo" />
            </div>
          </Link>
          <div className="row-value big">{item.name}</div>
          <div className="row-value">
            {typeof item.sector === "string"
              ? item.sector
              : item.sector && this.state.allSectors[item.sector].name}
          </div>
          <div className="row-value">{item.salesStage}</div>
          <div className="row-value">{item.salesManager}</div>
          <div className="row-value sm right">
            <img
              src={TerritoryIcon[territory]}
              alt="flag"
              style={{
                height: "40px",
                objectFit: "contain",
              }}
            />
          </div>
          <div className="row-value">
            <button className="btn" onClick={this.goToBrandAdmin(item)}>
              Edit
            </button>
          </div>
        </div>
      );
    });
  };

  handleSalesManagerChanged = (value) => {
    this.setState({
      salesManager: value,
    });
  };

  handleBrandNameFilterChanged = (value) => {
    this.setState({
      brandNameFilter: value,
    });
  };

  handleSectorFilterChanged = (value) => {
    this.setState({
      sectorFilter: value,
    });
  };

  handleStageFilterChanged = (value) => {
    this.setState({
      stageFilter: value,
    });
  };
  handleTerritoryFilterChanged = (value) => {
    this.setState({ territoryFilter: value });
  };
  render() {
    const {
      sectorFilter,
      salesManager,
      brandNameFilter,
      stageFilter,
      isLoading,
      territoryFilter,
      total_brands,
    } = this.state;
    if (!this.props.location.state) return <Redirect to="/" />;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return (
      <div id="page-container">
        <Header username={username} role={role} />
        <main id="main-container" className="channel-container">
          <div className="content">
            {!isLoading ? (
              <React.Fragment>
                <div className="add-brand-filter-container">
                  <div className="sales-filter-group">
                    <p className="group-label">Sales Team</p>
                    <div className="input-container">
                      <Select
                        value={salesManager}
                        onChange={this.handleSalesManagerChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...SalesManagerOptions,
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group name-filter">
                    <p className="group-label">Name Filter</p>
                    <div className="input-container">
                      <Select
                        value={brandNameFilter}
                        onChange={this.handleBrandNameFilterChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...Characters.map((item) => ({
                            value: item,
                            label: item,
                          })),
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group territory-filter">
                    <p className="group-label">Territory</p>
                    <div className="input-container">
                      <Select
                        value={territoryFilter}
                        onChange={this.handleTerritoryFilterChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...TerritoryOptions,
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group">
                    <p className="group-label">Sector Filter</p>
                    <div className="input-container">
                      <Select
                        value={sectorFilter}
                        onChange={this.handleSectorFilterChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...SectorOptions,
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group">
                    <p className="group-label">Stage</p>
                    <div className="input-container">
                      <Select
                        value={stageFilter}
                        onChange={this.handleStageFilterChanged}
                        options={stageOptions.map((option) => ({
                          value: option,
                          label: option,
                        }))}
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-green post add-new-brand"
                    data-toggle="modal"
                    data-target="#add_brand"
                  >
                    Add a new brand
                  </button>
                </div>
                <div className="brands-container">
                  <div className="brandchannel-header">
                    <div className="logo-header">Client</div>
                    <div className="header-item big">Name</div>
                    <div className="header-item">Sector</div>
                    <div className="header-item">Sales Stage</div>
                    <div className="header-item">Sales Manager</div>
                    <div className="header-item sm right">Territory</div>
                    <div className="header-item"></div>
                  </div>
                  <div className="brand-items-container">
                    {this.showBrands()}
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            )}
          </div>
          <MyModal
            addImage={this.addBrand}
            brands={total_brands}
            isSuperAdmin={role === 0}
          />
        </main>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    uid: state.uid,
    users: state.users,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(BrandChannel);



// WEBPACK FOOTER //
// ./src/screens/BrandChannel/index.js